import { useLocalStorage, useStorage } from '@vueuse/core'
import queryCart from '@/graphql/queries/queryCart.graphql'
import { getItemsForMiniCart } from '~/utils/getItemsForMiniCart'

async function miniCart() {
    if (process.server || !navigator.cookieEnabled) {
        return
    }

    const { getCartId } = useCart()
    const mageCacheStorage: Record<string, any> = useLocalStorage('mage-cache-storage', {})

    if (mageCacheStorage.value?.cart) {
        return
    }

    const { CART_ID } = useAppConfig()
    const cookieCartId = useCookie<string>(CART_ID)

    if (!cookieCartId.value) {
        return
    }

    const { data } = await useAsyncQuery(queryCart, {
        cartId: cookieCartId.value,
    })

    if (!data.value?.cart) {
        getCartId(true)
        return
    }

    const { cartItems, subtotal } = getItemsForMiniCart(data.value)

    const summary_count = data.value.cart.items.reduce(
        (sum: number, { quantity }: { quantity: number }) => sum + quantity,
        0,
    )

    const event = new CustomEvent('CUSTOMER_DATA_CART_CHANGE', {
        detail: {
            cart: {
                items: cartItems,
                subtotal,
                summary_count,
            },
        },
    })

    window.dispatchEvent(event)
    useStorage(
        'mage-cache-storage',
        {
            cart: {
                items: cartItems,
                subtotal,
                summary_count,
            },
        },
        localStorage,
        { mergeDefaults: true },
    )
}

export default miniCart
